import {Service, signal} from '@angular/core'
import {BehaviorSubject, ReplaySubject} from 'rxjs'
import {Advice} from '../model/advice'
import {KalpLoan} from '../model/kalp-loan'
import {Questions} from './proposal.service'

export interface ContactInfo {
  email?: string
  mobile?: string
}


@Service()
export class StaticDataService {

  /**
   * We send empty advice to simplify testing a bit.
   */
  public advice$: BehaviorSubject<Advice[]> = new BehaviorSubject<Advice[]>([new Advice()])

  public plural = signal(false)

  /**
   * This should be the active list of loans that are in the new
   * scenarios. Filtered on property etc.
   */
  public newLoans$: BehaviorSubject<KalpLoan[]> = new BehaviorSubject<KalpLoan[]>([])

  public questions$ = new BehaviorSubject<Questions>({
    q3: -1,
    q4: -1,
    q5: -1,
    q6: -1
  })

  public comment$ = new BehaviorSubject<string>('')

  public followAdvice$ = new BehaviorSubject<string>('')

  public contactInfo$ = new BehaviorSubject<[ContactInfo, ContactInfo]>([{}, {}])

  public reset$ = new ReplaySubject<any>(1)


  public reset(): void {
    this.comment$.next('')
    this.questions$.next({
      q3: -1,
      q4: -1,
      q5: -1,
      q6: -1
    })
    this.newLoans$.next([])
    this.plural.set(false)
    this.advice$.next([])
    this.followAdvice$.next('')
    this.contactInfo$.next([{}, {}])
    this.reset$.next(undefined)
  }
}
